import { render, staticRenderFns } from "./oscilloscope.vue?vue&type=template&id=947251ec&"
import script from "./oscilloscope.vue?vue&type=script&lang=ts&"
export * from "./oscilloscope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports